import arrayMoveMutable from './arrayMoveMutable'

export default function arrayMove<T>(
  value: T[],
  fromIndex: number,
  toIndex: number
): T[] {
  const array = [...value]

  arrayMoveMutable(array, fromIndex, toIndex)

  return array
}
